(function () {
    var copyTimer = false;
    var clearCopyTimer = function () {
        clearTimeout(copyTimer);
        copyTimer = false;
    };
    $(document).delegate('.js-m-inp-copy', 'click', function () {
        if (copyTimer) clearCopyTimer();
        $('.js-m-inp-copy').removeClass('m-inp-copy--active o-btn--active');
        var $btn = $(this);
        var $group = $btn.parents('.m-inp-copy-group');
        var $inp = $group.find('input');
        $inp.select();
        document.execCommand("copy");
        $btn.addClass('m-inp-copy--active o-btn--active');
        copyTimer = setTimeout(function () {
            $btn.removeClass('m-inp-copy--active o-btn--active');
            clearCopyTimer();
        }, 5000);
        return false;
    });
})();
